<template>
  <div class="md:flex">
    <!-- first -->
    <div class="m-2 md:w-3/12 w-full max-w-72 flex">
      <div class="w-full h-64 xl:h-96">
        <div class="ssc-square mb w-full h-64"></div>
      </div>

      <!-- actions -->
      <div class="block md:hidden">
        <div class="mt-2 pb-2">
          <ul class="flex">
            <li class="xs:mr-2 mr-0 w-10 h-10">
              <div class="ssc-circle"></div>
            </li>
            <li class="xs:mr-2 w-10 h-10">
              <div class="ssc-circle"></div>
            </li>
            <li class="w-10 h-10">
              <div class="ssc-circle"></div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- middle content -->
    <div class="m-2 relative flex-1 flex xl:flex-nowrap flex-wrap">
      <div class="xl:border-0 md:border-l md:pl-2 border-gray-600 flex-1">
        <!-- actions -->
        <div class="hidden md:block">
          <div class="mt-2 pb-2">
            <ul class="flex">
              <li class="xs:mr-2 mr-0 w-10 h-10">
                <div class="ssc-circle"></div>
              </li>
              <li class="xs:mr-2 w-10 h-10">
                <div class="ssc-circle"></div>
              </li>
              <li class="w-10 h-10">
                <div class="ssc-circle"></div>
              </li>
            </ul>
          </div>
        </div>
        <div class="w-full">
          <div class="ssc-line"></div>
          <div class="ssc-line"></div>
          <div class="ssc-line"></div>
          <div class="ssc-line"></div>
          <div class="ssc-line"></div>
          <div class="ssc-line"></div>
        </div>

        <div class="w-16 my-4">
          <div class="ssc-line"></div>
        </div>
        <div class="font-semibold text-lg mb-2">
          <div class="w-8 mb-4">
            <div class="ssc-line"></div>
          </div>
          <!-- casts -->
          <ul class="grid grid-gap-2 grid-cols-2 s:grid-cols-3 xs:grid-cols-5">
            <li
              v-for="(cast, index) in Array(5).fill()"
              :key="index"
              class="text-center text-gray-500 p-2 hidden xs:block"
            >
              <div class="h-24 mb-2">
                <div class="ssc-square w-full"></div>
              </div>
            </li>
            <li
              v-for="(cast, index) in Array(6).fill()"
              :key="index"
              class="text-center text-gray-500 p-2 block xs:hidden"
            >
              <div class="h-10 shaddow">
                <div class="ssc-square mb w-full h-10"></div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- Last -->
    <div class="md:border-l pl-3 border-gray-600 lg:w-72">
      <div class="mb-4">
        <div class="w-24 mb-4">
          <div class="ssc-head-line"></div>
        </div>
        <!-- details -->
        <div
          class="w-48 mb-2"
          v-for="(line, index) in Array(6).fill()"
          :key="index"
        >
          <div class="ssc-line"></div>
        </div>
      </div>
    </div>
  </div>
</template>
